/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface PasswordVerifyChallenge
 */
export interface PasswordVerifyChallenge {
    /**
     * 
     * @type {string}
     * @memberof PasswordVerifyChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordVerifyChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof PasswordVerifyChallenge
     */
    authentication_method: FactorMethod;
}



/**
 * Check if a given object implements the PasswordVerifyChallenge interface.
 */
export function instanceOfPasswordVerifyChallenge(value: object): value is PasswordVerifyChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function PasswordVerifyChallengeFromJSON(json: any): PasswordVerifyChallenge {
    return PasswordVerifyChallengeFromJSONTyped(json, false);
}

export function PasswordVerifyChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordVerifyChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
    };
}

export function PasswordVerifyChallengeToJSON(json: any): PasswordVerifyChallenge {
    return PasswordVerifyChallengeToJSONTyped(json, false);
}

export function PasswordVerifyChallengeToJSONTyped(value?: PasswordVerifyChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
    };
}

